import { render, staticRenderFns } from "./headerText.vue?vue&type=template&id=5f37ae31&"
import script from "./headerText.vue?vue&type=script&lang=js&"
export * from "./headerText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports